module.exports = __webpack_public_path__ + "static/media/hero-image.d450d3c1.png";